// ファイル名に使えない文字を置換する
export const sanitizeFilename = (name: string): string =>
  // eslint-disable-next-line no-control-regex
  name.replace(/[\\/:*?"<>|\x00-\x1f]/g, '_').trim();

// Blobをファイルとしてダウンロードさせる
export const saveBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = sanitizeFilename(filename);
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
